// Keys of built-in report dimensions the UI treats specially (backend `DimensionDefinition.key`).
export const DIMENSION_KEY_USER = 'user';
export const DIMENSION_KEY_PROJECT = 'project';
